"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const Label = (0, react_1.forwardRef)(({ children, className, error, id, target, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsx)("label", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('usa-label', error && 'usa-label--error', className), id: id, ...props, htmlFor: target, children: children }));
});
exports.default = Label;
